import { PermissionsTab } from '@webitel/ui-datalist/permissions';
import { AdminSections, WtObject } from '@webitel/ui-sdk/enums';

import RouteNames from '../../../../../app/router/_internals/RouteNames.enum';
import AgentsRouteNames from './_internals/AgentsRouteNames.enum';

const Agents = () => import('../components/the-agents.vue');
const Agent = () => import('../components/opened-agent.vue');
const General = () => import('../components/opened-agent-general.vue');
const Skills = () =>
	import('../modules/skills/components/opened-agent-skills.vue');
const Queues = () =>
	import('../modules/queues/components/opened-agent-queues.vue');
const Subordinates = () =>
	import('../modules/subordinates/components/opened-agent-subordinates.vue');
const Wfm = () => import('../components/opened-agent-wfm.vue');

const AgentRoutes = [
	{
		path: '/contact-center/agents',
		name: RouteNames.AGENTS,
		component: Agents,
		meta: {
			WtObject: WtObject.Agent,
			UiSection: AdminSections.Agents,
		},
		children: [
			{
				path: 'history/:historyId?',
				name: AgentsRouteNames.HISTORY,
				component: Agents,
			},
		],
	},
	{
		path: '/contact-center/agents/:id',
		name: `${RouteNames.AGENTS}-card`,
		redirect: {
			name: AgentsRouteNames.GENERAL,
		},
		component: Agent,
		meta: {
			WtObject: WtObject.Agent,
			UiSection: AdminSections.Agents,
		},
		children: [
			{
				path: 'general',
				name: AgentsRouteNames.GENERAL,
				component: General,
			},
			{
				path: 'skills/:skillId?',
				name: AgentsRouteNames.SKILLS,
				component: Skills,
			},
			{
				path: 'queues',
				name: AgentsRouteNames.QUEUES,
				component: Queues,
			},
			{
				path: 'subordinates/:subordinateId?',
				name: AgentsRouteNames.SUBORDINATES,
				component: Subordinates,
			},
			{
				path: 'wfm',
				name: AgentsRouteNames.WFM,
				component: Wfm,
			},
			{
				path: 'permissions/:permissionId?',
				name: AgentsRouteNames.PERMISSIONS,
				component: PermissionsTab,
			},
		],
	},
];

export default AgentRoutes;
